module.exports = __webpack_public_path__ + "static/rock2-d6ee96e9912c967aca3373a5d5da6a65.svg";